import { useEffect, useState } from 'react'
import { useAudioEngine } from './hooks/audio-engine.js'

/** Default input hook, reactive to handle changes in the devices, including permissions */
export const useDefaultInput = () => {
  const engine = useAudioEngine()
  const [input, setInput] = useState(engine?.defaultInput)

  useEffect(() => {
    const handleChange = () => {
      setInput(engine?.defaultInput)
    }
    engine.addEventListener('devicechange', handleChange)
    return () => {
      engine.removeEventListener('devicechange', handleChange)
    }
  }, [engine])

  return input
}
